module.exports = __webpack_public_path__ + "static/media/client_border.905805e0.svg";